import React from "react";
import { Link } from "react-router";
import { Divider, Button } from "../Controls";
import texts from "../../assets/strings/select";
import wgbhImage from "../../assets/images/2018/logos/wgbh.png";
import marchImage from "../../assets/images/2018/logos/march.png";
import feedamImage from "../../assets/images/2018/logos/feedam.png";
import doctorsImage from "../../assets/images/2018/logos/doctors.png";
import nprImage from "../../assets/images/2018/logos/npr.png";

const imageMapping = {
  "042104397": wgbhImage,
  "131846366": marchImage,
  "363673599": feedamImage,
  "133433452": doctorsImage,
  "520907625": nprImage
};
import "./styles.less";

const getGuidestarURL = id => {
  const url = "https://www.guidestar.org/organizations/{{ein}}/page.aspx";
  const ein = `${id.toString().slice(0, 2)}-${id
    .toString()
    .slice(2, id.length)}`;
  return url.replace("{{ein}}", ein);
};
const CharityCard = ({
  charity,
  description,
  onClick,
  showActions,
  isResponse
}) => (
  <div className="charity" key={`featured-${charity.ein}`}>
    <div className="charity-logo">
      <img className="logo-image" src={imageMapping[charity.ein]} />
      <div className="charity-info-address">
        <h4>EIN:&nbsp;{charity.ein}</h4>
        <h4>Address:&nbsp;{charity.address}</h4>
      </div>
    </div>
    <div className="charity-info">
      <div className="charity-info-address">
        <h4>EIN:&nbsp;{charity.ein}</h4>
        <h4>Address:&nbsp;{charity.address}</h4>
      </div>
      <h3>{charity.name}</h3>
      <p className="description">{description}</p>
      {showActions ? (
        <div className="actions">
          <Button primary={true} large={true} onClick={() => onClick(charity)}>
            <Link to={isResponse ? "/details/response" : "/details/personal"}>
              {texts.actions.select}
            </Link>
          </Button>
          <Button
            accent={true}
            large={true}
            label={texts.actions.info}
            onClick={() => window.open(getGuidestarURL(charity.ein), "_blank")}
          />
        </div>
      ) : null}
    </div>
  </div>
);

export default CharityCard;



// WEBPACK FOOTER //
// ./components/SelectCharity/CharityCard.js